import React from 'react';
import { Button } from "./button";
import { Card, CardContent, CardHeader, CardTitle } from "./card";
import { AlertCircle } from "lucide-react";

function ErrorModal({ isOpen, message, title = "Error", onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-700">
            <AlertCircle className="h-5 w-5" />
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">
            {message}
          </p>
          <div className="flex justify-end">
            <Button
              variant="default"
              className="bg-gray-800 text-white hover:bg-gray-700"
              onClick={onClose}
            >
              OK
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ErrorModal;
